export default __webpack_public_path__ + "static/banner2@2x-64540b0ee95ffb868c567af268b3ee50.jpg";